<template>
    <ul>
        <li v-for="part in salesItem.parts">
            <span>{{ part }}</span>
            <button @click.prevent="deleteEmit(part)">Ta bort</button>
            <button @click.prevent="printEmit(part)">Skriv ut etikett</button>
            <a :href="`${apiUrl}/tradera_stores/${storeId}/sales_items/${salesItem.id}/parts/${part}/print`" class="button" target="_blank">Hämta etikett</a>
        </li>
    </ul>
</template>

<script>
export default {
    name: 'SalesItemPartList',
    props: ['salesItem', 'apiUrl', 'storeId'],
    methods: {
        deleteEmit(part_number) {
            this.$emit('delete', part_number);
        },
        printEmit(part_number) {
            this.$emit('print', part_number);
        }
    }
}
</script>
